namespace TabAurous.SalesOrder {
    export namespace OrderItemsForPurchaseService {
        export const baseUrl = 'SalesOrder/OrderItemsForPurchase';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderItemsForPurchase/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsForPurchaseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
